
import { ServiceOrder, CreateNewServiceOrder } from "../../entities/service-order";
import { Formik, FormikHelpers, FormikProps, Form, Field } from "formik";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import supabase from "../../shared/database/supabase";
import { toast, ToastContainer } from "react-toastify";
import { createServiceOrder } from "../../entities/service-order/api";
import CostumerAutocompleteSearchBar from "../../entities/costumer/ui/costumer-autocomplete-search-bar.component";
import { Costumer } from "../../entities/costumer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const CreateServiceOrder = () => {
  const navigate = useNavigate();
  const [costumer, setCostumer] = useState<Costumer>({} as Costumer);
  const user = supabase.auth.user();

  const updateCostumer = (cost: Costumer) => {
    setCostumer(cost);
  };

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          width: "100%",
          minHeight: "72vh",
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography component="h1" variant="h4">
          Adicionar Ordem de Serviço
        </Typography>
        <Paper
          elevation={3}
          sx={{
            marginTop: 4,
            padding: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Formik
            initialValues={CreateNewServiceOrder()}
            onSubmit={(
              values: ServiceOrder,
              formikHelpers: FormikHelpers<ServiceOrder>
            ) => {
              const formkiCreateServiceOrder = async () => {
                try {
                  if (!costumer.id) {
                    formikHelpers.setSubmitting(false);
                    return toast.error("Selecione um cliente antes de adicionar a ordem de serviço.");
                  }
                  if (!user) {
                    formikHelpers.setSubmitting(false);
                    return toast.error("Usuário não encontrado.");
                  }
                  values.costumerId = costumer.id;
                  values.createdBy = user.id;
                  const res = await createServiceOrder(values);

                  if (res?.error) {
                    formikHelpers.setSubmitting(false);
                    return toast.error(res.error.message);
                  }

                  formikHelpers.setSubmitting(false);
                  toast.success("Ordem de serviço adicionada com sucesso!");
                  navigate("/service-orders/" + res.data.id + "/update");
                  formikHelpers.resetForm();
                  setCostumer({} as Costumer);

                } catch (err) {
                  toast.error("Erro ao adicionar ordem de serviço");
                  formikHelpers.setSubmitting(false);
                }
              };
              formkiCreateServiceOrder();
            }}
          >
            {(formikProps: FormikProps<ServiceOrder>) => (
              <Form noValidate autoComplete="off" style={{ width: "100%" }}>
                <Grid item xs={12} sm={12} >
                  <CostumerAutocompleteSearchBar
                    value={costumer}
                    onChange={(c) => updateCostumer(c || {} as Costumer)} />
                </Grid>
                <Grid container spacing={2} mt={2}>
                  <Grid item xs={12} mt={3}>
                    <LoadingButton sx={{ width: '100%' }}
                      type="submit"
                      variant="contained"
                      loading={formikProps.isSubmitting}
                      disabled={formikProps.isSubmitting}
                    >
                      Adicionar Ordem de Serviço
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Paper>
      </Box>
      <ToastContainer />
    </Container>
  );
};

export default CreateServiceOrder;